module.exports = __webpack_public_path__ + "img/bay_of_fires_ba_list.3ec069fb.jpg";